import { render, staticRenderFns } from "./TreeNodeDocPackage.vue?vue&type=template&id=4607d026&"
import script from "./TreeNodeDocPackage.vue?vue&type=script&lang=js&"
export * from "./TreeNodeDocPackage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/tgs-automation/tgs-automation/mojaweb/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4607d026')) {
      api.createRecord('4607d026', component.options)
    } else {
      api.reload('4607d026', component.options)
    }
    module.hot.accept("./TreeNodeDocPackage.vue?vue&type=template&id=4607d026&", function () {
      api.rerender('4607d026', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/document-package/components/TreeNodeDocPackage.vue"
export default component.exports